module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-4"
  }, [_c('app-header'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "img-upload"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panel),
      expression: "panel"
    }],
    staticClass: "img-container"
  }, [_c('img', {
    attrs: {
      "id": "image",
      "src": _vm.panelImageUrl,
      "alt": "Picture"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "id": "img-button-cancel",
      "dark": ""
    },
    on: {
      "click": _vm.cancelPanel
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "id": "img-button-submit",
      "dark": ""
    },
    on: {
      "click": _vm.cropperImage
    }
  }, [_vm._v(_vm._s(_vm.$t("common.apply")))])], 1)]), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.hideBlock
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "profile-head"
  }, [_c('div', {
    staticClass: "profile-top",
    style: ({
      backgroundImage: 'url(' + _vm.userDetail.coverImage + ')'
    })
  }, [_c('Upload', {
    ref: "upload",
    attrs: {
      "name": "coverImage",
      "max-size": 1024,
      "format": ['jpg', 'jpeg', 'png'],
      "action": _vm.uploadCoverImageUrl,
      "headers": _vm.headers,
      "with-credentials": true,
      "show-upload-list": false,
      "before-upload": _vm.uploadCoverImageBefore
    }
  }, [_c('div', [_c('v-btn', {
    staticClass: "mt-4 mr-4 right",
    staticStyle: {
      "position": "absolute",
      "right": "0px"
    },
    attrs: {
      "small": "",
      "flat": "",
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("userSetting.changeCoverImage")))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "profile-bottom"
  }, [_c('div', {
    staticClass: "picture"
  }, [_c('div', {
    staticClass: "user-image text-xs-center mb-3"
  }, [_c('Upload', {
    ref: "upload",
    attrs: {
      "name": "upfile",
      "max-size": 1024,
      "format": ['jpg', 'jpeg', 'png'],
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "with-credentials": true,
      "before-upload": _vm.beforeUpload,
      "show-upload-list": false
    }
  }, [_c('v-avatar', {
    attrs: {
      "color": "primary pointer",
      "size": "100",
      "title": _vm.$t('userSetting.uploadImgTitle')
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image != null),
      expression: "userDetail.image != null"
    }],
    attrs: {
      "src": _vm.userDetail.image,
      "alt": _vm.userDetail.userName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image == null),
      expression: "userDetail.image == null"
    }],
    staticClass: "font-50 white--text"
  }, [_vm._v("\n                                                " + _vm._s(_vm.userDetail.userName != null ? _vm.userDetail.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                            ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "user-list-content mb-5"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('h3', {
    staticClass: "fw-700"
  }, [_vm._v(_vm._s(_vm.userDetail.nickName) + " (" + _vm._s(_vm.userDetail.reputationScore) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "font-16 fw-500 mt-3"
  }, [_c('span', {
    staticClass: "mx-3"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fas fa-at")]), _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.userDetail.userName))])], 1), _vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fas fa-calendar-alt")]), _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.regTimeFormat(_vm.userDetail.regTime)))])], 1)])])])])])])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mt-5": "",
      "mb-5": "",
      "pb-5": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": "",
      "lg3": ""
    }
  }, [_c('div', {
    staticClass: "inbox-head"
  }, [_c('div', {
    staticClass: "mailbox-items-warp"
  }, [_c('div', {
    staticClass: "app-card"
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userSetting.account')
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('account')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("account_box")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                " + _vm._s(_vm.$t("userSetting.account")) + "\n                            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userSetting.password')
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('password')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("lock")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                " + _vm._s(_vm.$t("userSetting.password")) + "\n                            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userSetting.kyc.kyc')
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('kyc')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fas fa-id-card")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                " + _vm._s(_vm.$t("userSetting.kyc.kyc")) + "\n                            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userSetting.privacyAndSafety')
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('privacyAndSafety')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("security")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                " + _vm._s(_vm.$t("userSetting.privacyAndSafety")) + "\n                            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userSetting.googleAuthentication')
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('googleAuthentication')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("phonelink_setup")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                " + _vm._s(_vm.$t("userSetting.googleAuthentication")) + "\n                            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "title": _vm.$t('userSetting.accountBinding')
    },
    on: {
      "click": function($event) {
        return _vm.getMenuData('accountBinding')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fas fa-globe-europe")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                " + _vm._s(_vm.$t("userSetting.accountBinding")) + "\n                            ")])], 1)], 1)], 1)], 1)])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "inbox-content",
    attrs: {
      "xs12": "",
      "md7": "",
      "lg9": ""
    }
  }, [_c('div', {
    staticClass: "inbox-content-wrap"
  }, [_c('v-card', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAccount),
      expression: "isShowAccount"
    }],
    staticClass: "ml-3 mr-3 mb-5"
  }, [_c('h2', {
    staticClass: "fw-700 mb-3"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.account")))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t("userSetting.username")))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('userSetting.username'),
      "disabled": ""
    },
    model: {
      value: (_vm.userDetail.userName),
      callback: function($$v) {
        _vm.$set(_vm.userDetail, "userName", $$v)
      },
      expression: "userDetail.userName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', [_c('span', [_vm._v(_vm._s(_vm.$t("userSetting.nickName")))])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('userSetting.nickName'),
      "disabled": !_vm.isShowNickNameInput
    },
    model: {
      value: (_vm.userDetail.nickName),
      callback: function($$v) {
        _vm.$set(_vm.userDetail, "nickName", $$v)
      },
      expression: "userDetail.nickName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.edit'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowNickNameInput),
      expression: "!isShowNickNameInput"
    }],
    on: {
      "click": function($event) {
        _vm.isShowNickNameInput = !_vm.isShowNickNameInput
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.confirm'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowNickNameInput),
      expression: "isShowNickNameInput"
    }],
    on: {
      "click": _vm.updateNickName
    }
  }, [_vm._v("fas fa-check")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.cancel'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowNickNameInput),
      expression: "isShowNickNameInput"
    }],
    staticClass: "ml-3",
    on: {
      "click": _vm.showNickNameInput
    }
  }, [_vm._v("fas fa-times")])], 1)], 1)])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t("userSetting.email")))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('userSetting.email'),
      "disabled": !_vm.isShowRegEmailInput
    },
    model: {
      value: (_vm.userDetail.regEmail),
      callback: function($$v) {
        _vm.$set(_vm.userDetail, "regEmail", $$v)
      },
      expression: "userDetail.regEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.edit'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowRegEmailInput),
      expression: "!isShowRegEmailInput"
    }],
    on: {
      "click": function($event) {
        _vm.isShowRegEmailInput = !_vm.isShowRegEmailInput
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.confirm'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowRegEmailInput),
      expression: "isShowRegEmailInput"
    }],
    on: {
      "click": _vm.sendUpdateRegEmail
    }
  }, [_vm._v("fas fa-check")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.cancel'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowRegEmailInput),
      expression: "isShowRegEmailInput"
    }],
    staticClass: "ml-3",
    on: {
      "click": _vm.showRegEmailInput
    }
  }, [_vm._v("fas fa-times")])], 1)], 1)])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t("userSetting.invitationCode")))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pointer",
    attrs: {
      "label": _vm.$t('userSetting.invitationCode'),
      "disabled": ""
    },
    model: {
      value: (_vm.userDetail.invitationCode),
      callback: function($$v) {
        _vm.$set(_vm.userDetail, "invitationCode", $$v)
      },
      expression: "userDetail.invitationCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('userSetting.copyInvitationLink'),
      "placement": "bottom"
    }
  }, [_c('span', {
    attrs: {
      "id": "invitationLink",
      "data-clipboard-text": _vm.invitationLink
    }
  }, [_c('v-icon', {
    on: {
      "click": _vm.copyInvitationLink
    }
  }, [_vm._v("fas fa-copy")])], 1)])], 1)])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t("userSetting.avatar")))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('userSetting.avatar'),
      "disabled": !_vm.isShowImageInput
    },
    model: {
      value: (_vm.userDetail.image),
      callback: function($$v) {
        _vm.$set(_vm.userDetail, "image", $$v)
      },
      expression: "userDetail.image"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.edit'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowImageInput),
      expression: "!isShowImageInput"
    }],
    on: {
      "click": function($event) {
        _vm.isShowImageInput = !_vm.isShowImageInput
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.confirm'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowImageInput),
      expression: "isShowImageInput"
    }],
    on: {
      "click": _vm.updateImage
    }
  }, [_vm._v("fas fa-check")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.cancel'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowImageInput),
      expression: "isShowImageInput"
    }],
    staticClass: "ml-3",
    on: {
      "click": _vm.showImageInput
    }
  }, [_vm._v("fas fa-times")])], 1)], 1)])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t("userSetting.coverImage")))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('userSetting.coverImage'),
      "disabled": !_vm.isShowCoverImageInput
    },
    model: {
      value: (_vm.userDetail.coverImage),
      callback: function($$v) {
        _vm.$set(_vm.userDetail, "coverImage", $$v)
      },
      expression: "userDetail.coverImage"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.edit'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowCoverImageInput),
      expression: "!isShowCoverImageInput"
    }],
    on: {
      "click": function($event) {
        _vm.isShowCoverImageInput = !_vm.isShowCoverImageInput
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.confirm'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCoverImageInput),
      expression: "isShowCoverImageInput"
    }],
    on: {
      "click": _vm.updateCoverImage
    }
  }, [_vm._v("fas fa-check")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.cancel'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCoverImageInput),
      expression: "isShowCoverImageInput"
    }],
    staticClass: "ml-3",
    on: {
      "click": _vm.showCoverImageInput
    }
  }, [_vm._v("fas fa-times")])], 1)], 1)])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t("userSetting.timeZone")))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.timeZoneList,
      "item-text": "name",
      "item-value": "timeZoneId",
      "label": _vm.$t('userSetting.timeZone'),
      "disabled": !_vm.isShowTimeZoneInput
    },
    on: {
      "input": _vm.updateTimeZone
    },
    model: {
      value: (_vm.userDetail.timeZoneId),
      callback: function($$v) {
        _vm.$set(_vm.userDetail, "timeZoneId", $$v)
      },
      expression: "userDetail.timeZoneId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.edit'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowTimeZoneInput),
      expression: "!isShowTimeZoneInput"
    }],
    on: {
      "click": function($event) {
        _vm.isShowTimeZoneInput = !_vm.isShowTimeZoneInput
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": _vm.$t('common.confirm'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowTimeZoneInput),
      expression: "isShowTimeZoneInput"
    }],
    on: {
      "click": function($event) {
        _vm.isShowTimeZoneInput = !_vm.isShowTimeZoneInput
      }
    }
  }, [_vm._v("fas fa-check")])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPassword),
      expression: "isShowPassword"
    }],
    staticClass: "ml-3 mr-3"
  }, [_c('h2', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.password")))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "font-14 fw-500"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.passwordMsg")))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "formPassword",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.formPasswordValid),
      callback: function($$v) {
        _vm.formPasswordValid = $$v
      },
      expression: "formPasswordValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "password",
      "rules": _vm.currentPasswordRules,
      "label": _vm.$t('userSetting.currentPassword'),
      "required": ""
    },
    model: {
      value: (_vm.formPassword.passWord),
      callback: function($$v) {
        _vm.$set(_vm.formPassword, "passWord", $$v)
      },
      expression: "formPassword.passWord"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pointer font-12",
    on: {
      "click": _vm.goPassword
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("userSetting.forgotPassword")) + "?")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "password",
      "rules": _vm.newPasswordRules,
      "label": _vm.$t('userSetting.newPassword'),
      "required": ""
    },
    model: {
      value: (_vm.formPassword.newPassWord),
      callback: function($$v) {
        _vm.$set(_vm.formPassword, "newPassWord", $$v)
      },
      expression: "formPassword.newPassWord"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "password",
      "rules": _vm.confirmNewPasswordRules,
      "label": _vm.$t('userSetting.verifyPassword'),
      "required": ""
    },
    model: {
      value: (_vm.formPassword.confirmNewPassWord),
      callback: function($$v) {
        _vm.$set(_vm.formPassword, "confirmNewPassWord", $$v)
      },
      expression: "formPassword.confirmNewPassWord"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "primary",
      "outline": "",
      "small": ""
    },
    on: {
      "click": _vm.updatePassword
    }
  }, [_vm._v(_vm._s(_vm.$t("userSetting.saveChanges")))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowKyc),
      expression: "isShowKyc"
    }],
    staticClass: "ml-3 mr-3"
  }, [_c('h2', {
    staticClass: "fw-bold mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.kyc.kyc")))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.realNameAuthentication == '-1'),
      expression: "userDetail.realNameAuthentication == '-1'"
    }]
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("userSetting.kyc.beginMsg")))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outline": "",
      "small": ""
    },
    on: {
      "click": _vm.gotoKyc
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t("userSetting.kyc.begin")) + "\n                                    ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.realNameAuthentication == '-2'),
      expression: "userDetail.realNameAuthentication == '-2'"
    }]
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("userSetting.kyc.underReviewMsg")))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outline": "",
      "small": "",
      "disabled": ""
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("userSetting.kyc.underReview")) + "\n                                ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.realNameAuthentication == '1'),
      expression: "userDetail.realNameAuthentication == '1'"
    }]
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("userSetting.kyc.rejectedMsg")))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outline": "",
      "small": ""
    },
    on: {
      "click": _vm.gotoKyc
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("userSetting.kyc.rejected")) + "\n                                ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.realNameAuthentication == '0'),
      expression: "userDetail.realNameAuthentication == '0'"
    }]
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("userSetting.kyc.passedMsg")))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outline": "",
      "small": "",
      "disabled": ""
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("userSetting.kyc.passed")) + "\n                                ")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPrivacyAndSafety),
      expression: "isShowPrivacyAndSafety"
    }],
    staticClass: "ml-3 mr-3"
  }, [_c('h2', {
    staticClass: "fw-bold mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.privacyAndSafety")))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "font-md"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t("userSetting.emailNotifications")))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-4"
  }, [_c('v-checkbox', {
    attrs: {
      "color": "primary",
      "readonly": "",
      "label": _vm.$t('userSetting.receiveAuthEmail')
    },
    model: {
      value: (_vm.userRight.isReceiveAuthEmail),
      callback: function($$v) {
        _vm.$set(_vm.userRight, "isReceiveAuthEmail", $$v)
      },
      expression: "userRight.isReceiveAuthEmail"
    }
  }), _vm._v("\n                                    " + _vm._s(_vm.$t("userSetting.receiveAuthEmailHint")) + "\n                                    "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": _vm.$t('userSetting.receivePushEmail')
    },
    model: {
      value: (_vm.userRight.isReceivePushEmail),
      callback: function($$v) {
        _vm.$set(_vm.userRight, "isReceivePushEmail", $$v)
      },
      expression: "userRight.isReceivePushEmail"
    }
  }), _vm._v("\n                                    " + _vm._s(_vm.$t("userSetting.receivePushEmailHint")) + "\n                                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "font-md mt-3"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t("userSetting.dataProtections")))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-4"
  }, [_c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": _vm.$t('userSetting.hideSipToken')
    },
    model: {
      value: (_vm.userRight.isHideSipToken),
      callback: function($$v) {
        _vm.$set(_vm.userRight, "isHideSipToken", $$v)
      },
      expression: "userRight.isHideSipToken"
    }
  }), _vm._v("\n                                    " + _vm._s(_vm.$t("userSetting.hideSipTokenHint")) + "\n                                ")], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userDetail.openAuthentication),
      expression: "!userDetail.openAuthentication"
    }]
  }, [_c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "primary",
      "outline": "",
      "small": "",
      "disabled": _vm.userRightVaild
    },
    on: {
      "click": _vm.updateUserRight
    }
  }, [_vm._v(_vm._s(_vm.$t("userSetting.saveChanges")))])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowGoogleAuthentication),
      expression: "isShowGoogleAuthentication"
    }],
    staticClass: "ml-3 mr-3"
  }, [_c('h2', {
    staticClass: "fw-bold mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.googleAuthentication")))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.openAuthentication),
      expression: "userDetail.openAuthentication"
    }]
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("userSetting.enabledMsg")))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userDetail.openAuthentication),
      expression: "!userDetail.openAuthentication"
    }]
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("userSetting.disabledMsg")))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.openAuthentication),
      expression: "userDetail.openAuthentication"
    }]
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outline": "",
      "small": ""
    },
    on: {
      "click": _vm.showDisableModal
    }
  }, [_vm._v(_vm._s(_vm.$t("userSetting.disable")))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userDetail.openAuthentication),
      expression: "!userDetail.openAuthentication"
    }]
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outline": "",
      "small": "",
      "loading": _vm.enableLoading
    },
    on: {
      "click": _vm.gotoAuthentication
    }
  }, [_vm._v(_vm._s(_vm.$t("userSetting.enable")))])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAccountBinding),
      expression: "isShowAccountBinding"
    }],
    staticClass: "ml-3 mr-3"
  }, [_c('h2', {
    staticClass: "fw-bold mb-5"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.accountBinding")))]), _vm._v(" "), _c('v-layout', {
    staticClass: "font-md",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "small-12 ml-3"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("userSetting.viewOrCopyHint")) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "small-12 mt-5 ml-3"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("fas fa-key")]), _vm._v(" "), _c('span', {
    staticClass: "ml-2 mr-5"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.token")) + ":")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userRight.isHideSipToken),
      expression: "userRight.isHideSipToken"
    }]
  }, [_vm._v("\n                                    " + _vm._s(_vm.userDetail.sipToken) + "\n                                ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userRight.isHideSipToken),
      expression: "!userRight.isHideSipToken"
    }]
  }, [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('userSetting.clickToCopy'),
      "placement": "bottom"
    }
  }, [_c('span', {
    staticClass: "pointer",
    attrs: {
      "id": "sipToken",
      "data-clipboard-text": _vm.userDetail.sipToken
    },
    on: {
      "click": _vm.copySipToken
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.userDetail.sipToken) + "\n                                        ")])])], 1), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "primary pointer",
      "title": _vm.$t('userSetting.refresh')
    },
    on: {
      "click": _vm.updateSipToken
    }
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br')], 1)])], 1)])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "red"
    }
  }, [_c('Modal', {
    attrs: {
      "align": "center"
    },
    model: {
      value: (_vm.isShowDisableModal),
      callback: function($$v) {
        _vm.isShowDisableModal = $$v
      },
      expression: "isShowDisableModal"
    }
  }, [_c('p', {
    staticStyle: {
      "font-family": "Helvetica-Bold",
      "color": "#333333",
      "font-size": "20px",
      "letter-spacing": "0",
      "line-height": "30px",
      "height": "40px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t("userSetting.disableModalTitle")))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.$t("userSetting.disableModalMsg")))]), _vm._v(" "), _c('v-form', {
    ref: "formDisableAuthentication",
    staticClass: "mt-5 mb-4"
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "enter-verify-code",
      "counter": 6,
      "rules": _vm.randomCodeRules,
      "single-line": "",
      "outline": ""
    },
    model: {
      value: (_vm.formDisableAuthentication.randomCode),
      callback: function($$v) {
        _vm.$set(_vm.formDisableAuthentication, "randomCode", $$v)
      },
      expression: "formDisableAuthentication.randomCode"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.formDisableAuthentication.id),
      callback: function($$v) {
        _vm.$set(_vm.formDisableAuthentication, "id", $$v)
      },
      expression: "formDisableAuthentication.id"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.formDisableAuthentication.authenticationSecret),
      callback: function($$v) {
        _vm.$set(_vm.formDisableAuthentication, "authenticationSecret", $$v)
      },
      expression: "formDisableAuthentication.authenticationSecret"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.$t("userSetting.disableModalContact")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer",
      "align": "center"
    },
    slot: "footer"
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.disableModalCancel
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.verityRandomCode('formDisableAuthentication')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.verify")))])], 1)], 1)], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-681d63fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/UserSetting.vue
// module id = 450
// module chunks = 0